module.exports = __webpack_public_path__ + "img/2_185.3d97b5b1.png";